import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';
import { GET_BENEFIT_GROUP_CATEORIES, GET_BENEFIT_GROUP_CATEORIES_SUCCESS, GET_BENEFIT_GROUP_CATEORIES_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getBenefitGroupCategories({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/benefit-group-categories`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_BENEFIT_GROUP_CATEORIES_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_BENEFIT_GROUP_CATEORIES_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_BENEFIT_GROUP_CATEORIES_ERROR, payload: error });
  }
}

export function* watchBenefitGroupCategories() {
  yield takeEvery(GET_BENEFIT_GROUP_CATEORIES, getBenefitGroupCategories);
}

function* getBenefitGroupCategoriesSaga() {
  yield all([fork(watchBenefitGroupCategories)]);
}

export default getBenefitGroupCategoriesSaga;
